exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#ecomotoriMap h3{padding:0 10px}#ecomotoriMap h3 .price-title{float:right}#ecomotoriMap .apexcharts-canvas{border:1px solid #999;margin-top:20px}#ecomotoriMap .copyright{text-align:right;margin-top:20px}#ecomotoriMap .copyright img{width:140px}", ""]);

// exports
